<script module>
  import { resolve } from '$app/paths'

  export const meta = {
    title: 'Notifications',
    teaser:
      'Learn how to stay in the loop with friends through easy setup of browser or\nTelegram notifications. Get step-by-step guidance for enabling alerts directly\nin your browser, or link Telegram for updates on the go.',
    sort: 5,
  }
</script>

<p>
  Wondering how to stay connected and get alerted when your friends kick off a
  session? We've got you covered with a couple of convenient options for
  notifications. Whether you prefer the straightforward approach of browser
  notifications or the flexibility of Telegram notifications, we'll walk you
  through the simple steps to get everything set up.
</p>
<h3>Browser Notifications</h3>
<p>
  Setting up browser notifications is a breeze. All you need to do is navigate
  to your <a href={resolve('/settings/notifications')}>notification settings</a> and
  toggle them on. When your browser prompts you, remember to click on "Allow" to enable
  notifications. This ensures you won't miss out on the fun!
</p>
<p>
  It's important to remember, though, that for these notifications to work, your
  browser needs to be running. And don't worry about being bombarded with
  unwanted marketing messages – we promise to only send you notifications that
  matter to you.
</p>
<h3>Telegram Notifications</h3>
<p>
  For those who are avid users of Telegram, you're in luck! You can easily link
  Telegram for notifications. Simply go to your
  <a href={resolve('/settings/notifications')}>notification settings</a>, click
  on the "link telegram" button, and follow the on-screen instructions to get
  started.
</p>
<p>
  Setup is straightforward, and this way, you can receive notifications directly
  through Telegram, regardless of whether your browser is open or not.
</p>
<p>
  Stay in the loop with these simple steps, and never miss a moment of the
  action with your friends!
</p>
